import React from 'react';

import Tooltip from '../../Tooltip';

import './styles.css';


const tooltipStyle = {
  marginLeft: '10px',
};

const withHint = (Component, hintText) => props => (
  <div styleName="withHintWrapper">
    <Tooltip
      styles={tooltipStyle}
      text={hintText}
    />
    <Component {...props} />
  </div>
);

export default withHint;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/withHint.js